import React, { Component } from "react";
import { observer } from "mobx-react";
import ProfileStore from "../../stores/ProfileStore";
import { ProfileState } from "../../stores/ProfileStore/Types";
import Landing from "./Landing";
import OngoingCourses from "./OngoingCourses";
import { AiCoursePicker, NewPricing } from "../Home/components";
import BrowseCourseCategories from "./BrowseCourseCategories";
import CompletedCourses from "./CompletedCourses";
import Certificates from "./Certificates";
import Leaderboard from "./Leaderboard";
import { CurrentUser } from "../../stores/CurrentUserStore/Types";
import PricingStore from "../../stores/PricingStore";
import Icons from "./components/Icons";
import { ProfileSidebarView } from "./ProfileSidebar";

interface Props {
  profileStore: ProfileStore;
  pricingStore: PricingStore;
  getCurrentUser: () => void;
  currentUser: CurrentUser;
  showProfileSidebar: boolean;
  handleShowProfileSidebar: (value: boolean, view?: ProfileSidebarView) => void;
  handleShowLoggedInSideBar: () => void;
  handleShowSettingsModal: (e: any, val: boolean) => void;
}

interface State {
  // showSettingsModal: boolean;
}

class Profile extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderPricing = (state) => {
    switch (state.kind) {
      case "ready":
        return (
          <NewPricing
            handleShowSignInSideBar={() => {}}
            pricing={state.pricing}
            showSigninSidebar={false}
          />
        );
      case "loading":
        return (
          <section className="pricing ui vertical center aligned segment">
            <div
              className="profile-section-loader profile-section-loader--pricing"
              aria-live="polite"
            >
              <div className="profile-section-loader__line profile-section-loader__line--short" />
              <div className="profile-section-loader__line profile-section-loader__line--long" />
              <div className="profile-section-loader__stats">
                <span />
                <span />
              </div>
            </div>
          </section>
        );
      default:
        return <div />;
    }
  };

  renderProfileSummaryLoader = () => (
    <header className="home-header profile-home-loading">
      <div className="container">
        <div className="profile-section-loader profile-section-loader--hero">
          <div className="profile-section-loader__avatar" />
          <div className="profile-section-loader__body">
            <div className="profile-section-loader__line profile-section-loader__line--short" />
            <div className="profile-section-loader__line profile-section-loader__line--long" />
            <div className="profile-section-loader__stats">
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      </div>
    </header>
  );

  renderIndependentSections = (
    currentUser: CurrentUser,
    profileResource = null,
    showAiPicker: boolean = false,
  ) => (
    <>
      <OngoingCourses
        className={showAiPicker ? "profile__ongoing-course" : ""}
        hasFinishedCourses={(profileResource?.enrolments?.finished || 0) > 0}
        key="ongoing-courses"
        userIsInUk={currentUser.is_in_uk}
      />
      {showAiPicker && (
        <AiCoursePicker
          key="ai-course-picker"
          userIsInUk={currentUser.is_in_uk}
        />
      )}
      {!showAiPicker && (
        <BrowseCourseCategories key="browse-course-categories" />
      )}
      <CompletedCourses
        key="completed-courses"
        userIsInUk={currentUser.is_in_uk}
      />
      <Certificates key="certificates" />
      <Leaderboard countries={profileResource?.countries} />
    </>
  );

  renderContent = (profileState: ProfileState) => {
    const {
      currentUser,
      pricingStore,
      showProfileSidebar,
      handleShowProfileSidebar,
      handleShowLoggedInSideBar,
      handleShowSettingsModal,
    } = this.props;
    const { pricingState } = pricingStore;

    switch (profileState.kind) {
      case "ready":
        if (profileState.profileResource.kind === "current-user-absent") {
          return (
            <div className="ui active inverted dimmer">
              <div className="ui text loader">Loading</div>
            </div>
          );
        } else {
          const { profileResource } = profileState;
          return (
            <div>
              <Landing
                profileResource={profileResource}
                profilePicture={
                  currentUser.kind === "current-user"
                    ? currentUser.profile_picture
                    : ""
                }
                currentUser={currentUser}
                profileStore={this.props.profileStore}
                getCurrentUser={this.props.getCurrentUser}
                showProfileSidebar={showProfileSidebar}
                handleShowProfileSidebar={handleShowProfileSidebar}
                handleShowLoggedInSideBar={handleShowLoggedInSideBar}
              />
              {this.renderIndependentSections(
                currentUser,
                profileResource,
                !profileResource.enrolments?.ongoing,
              )}
              {this.renderPricing(pricingState)}
            </div>
          );
        }
        break;
      case "loading":
        return (
          <div>
            {this.renderProfileSummaryLoader()}
            {this.renderIndependentSections(currentUser)}
            {this.renderPricing(pricingState)}
          </div>
        );

      default:
        break;
    }
  };

  render() {
    const { profileStore } = this.props;
    return (
      <>
        <Icons />
        <main className="facelift-landing-page facelift-profile-page" id="main">
          <div className="profile-header-wrapper">
            {this.renderContent(profileStore.state)}
          </div>
        </main>
      </>
    );
  }
}

export default observer(Profile);
